import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { warehouseStockSearchApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const warehouseStockSearch = createAsyncThunk('warehouseStockSearch', async (payload) => {
  return await warehouseStockSearchApi(payload);
});

const warehouseStockSearchSlice = createSlice({
  name: 'warehouseStockSearch', // Unique Name
  initialState,
  reducers: {
    warehouseStockSearchReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(warehouseStockSearch.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(warehouseStockSearch.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(warehouseStockSearch.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { warehouseStockSearchReset } = warehouseStockSearchSlice.actions;

export default warehouseStockSearchSlice.reducer;
